(function(){
if(customElements.get('atelier-cart-shipping'))return;
var countryPromise;
function getCountry(){
 if(countryPromise)return countryPromise;
 try{
  var saved=JSON.parse(sessionStorage.getItem('atelier_shopify_ip_country_v1'));
  if(saved && typeof saved.name==='string' && Date.now()-saved.time<1800000){
   countryPromise=Promise.resolve(saved.name);return countryPromise;
  }
 }catch(error){}
 var controller=new AbortController();
 var timer=setTimeout(function(){controller.abort();},5000);
 countryPromise=fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/')+'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false',{credentials:'same-origin',signal:controller.signal})
 .then(function(response){if(!response.ok)throw new Error('Country unavailable');return response.json();})
 .then(function(data){
  var detected=data.detected_values && data.detected_values.country;
  if(!detected || !/^[A-Z]{2}$/.test(detected.handle||'') || typeof detected.name!=='string' || !detected.name.trim() || detected.name.length>80)throw new Error('Invalid country');
  var country=detected.name.trim();
  try{sessionStorage.setItem('atelier_shopify_ip_country_v1',JSON.stringify({name:country,time:Date.now()}));}catch(error){}
  return country;
 }).catch(function(){return '';}).finally(function(){clearTimeout(timer);});
 return countryPromise;
}
customElements.define('atelier-cart-shipping',class extends HTMLElement{
 connectedCallback(){
  var element=this;
  getCountry().then(function(country){if(element.isConnected && country)element.textContent='Free Delivery to '+country;});
 }
});

if(!customElements.get('atelier-announcement')){
customElements.define('atelier-announcement',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.index=0;
  this.slides=Array.from(this.querySelectorAll('[data-announcement-slide]'));
  getCountry().then(country=>{if(this.isConnected && country)this.slides[0].textContent='FREE DELIVERY TO '+country.toUpperCase();});
  if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
   this.timer=setInterval(()=>{if(document.hidden || this.matches(':hover') || this.contains(document.activeElement))return;
    this.slides[this.index].classList.remove('is-active');this.slides[this.index].setAttribute('aria-hidden','true');
    this.index=(this.index+1)%this.slides.length;this.slides[this.index].classList.add('is-active');this.slides[this.index].removeAttribute('aria-hidden');
   },7000);
  }
 }
 disconnectedCallback(){clearInterval(this.timer);this.ready=false;}
});
}
})();